import { render, staticRenderFns } from "./add-client.vue?vue&type=template&id=75f0be0a&scoped=true&"
import script from "./add-client.vue?vue&type=script&lang=js&"
export * from "./add-client.vue?vue&type=script&lang=js&"
import style0 from "./add-client.vue?vue&type=style&index=0&id=75f0be0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f0be0a",
  null
  
)

export default component.exports